<form *ngIf="data.controls.length" [formGroup]="fg" (submit)="onSubmit()" class="card {{data.formClass}}">
  <div class="card-header">{{data.title ?? 'Form'}}</div>
  <div class="card-body" mat-dialog-content>
    <div class="grid grid-cols-12 gap-x-4">
      <div *ngIf="data.isRequesting$|async" class="col-span-12">
        <div class="alert alert-warning">Loading...</div>
      </div>

      <div *ngFor="let c of data.controls; let i = index" [class]="c.colClassName">

        <div [ngSwitch]="c.inputType" class="mb-4">

          <ng-container *ngSwitchCase="'empty'"></ng-container>

          <ng-container *ngSwitchCase="'search'">
            <ng-container *ngIf="fg.get(c.name)?.enabled">
              <app-simple-form-auto-complete-input [controlInfo]="c" [controlId]="i" [parentFormGroup]="fg">
              </app-simple-form-auto-complete-input>
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'date-range'">
            <ng-container *ngIf="fg.get(c.name)?.enabled">
              <app-simple-form-date-range-input [controlInfo]="c" [controlId]="i" [parentFormGroup]="fg">
              </app-simple-form-date-range-input>
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'date'">
            <ng-container *ngIf="fg.get(c.name)?.enabled">
              <app-simple-form-date-input [controlInfo]="c" [controlId]="i" [parentFormGroup]="fg">
              </app-simple-form-date-input>
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'checkbox'">
            <ng-container *ngIf="fg.get(c.name)?.enabled">
              <mat-checkbox [formControlName]="c.name" id="simple-input-text-form-{{i}}" [matTooltip]="c.toolTip ?? ''">
                {{c.alias ?? c.name}}
                <span *ngIf="c.required" class="text-red-400">*</span>
                <small *ngIf="c.label" class="text-muted text-xs">{{c.label}}</small>
              </mat-checkbox>
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'select'">
            <ng-container *ngIf="fg.get(c.name)?.enabled">
              <label for=" simple-input-text-form-{{i}}" class="form-label">
                {{c.alias ?? c.name}}
                <span *ngIf="c.required" class="text-red-400">*</span>
                <small *ngIf="c.label" class="text-muted text-xs">{{c.label}}</small>
              </label>
              <mat-select [formControlName]="c.name" class="form-control" id="simple-input-text-form-{{i}}">
                <mat-option *ngFor="let item of c.selectOptions$|async" [value]="item.value">{{item.key}}</mat-option>
              </mat-select>
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'number'">
            <ng-container *ngIf="fg.get(c.name)?.enabled">
              <label for="simple-input-text-form-{{i}}" class="form-label">
                {{c.alias ?? c.name}}
                <span *ngIf="c.required" class="text-red-400">*</span>
                <small *ngIf="c.label" class="text-muted text-xs">{{c.label}}</small>
              </label>
              <input [formControlName]="c.name" type="number" (keypress)="Helper.input.positiveNumeric($event)"
                [min]="c.minNumber|toNumber" [max]="c.maxNumber|toNumber" class="form-control"
                id="simple-input-text-form-{{i}}" [matTooltip]="c.toolTip ?? ''">
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'text'">
            <ng-container *ngIf="fg.get(c.name)?.enabled">
              <label for=" simple-input-text-form-{{i}}" class="form-label">
                {{c.alias ?? c.name}}
                <span *ngIf="c.required" class="text-red-400">*</span>
                <small *ngIf="c.label" class="text-muted text-xs">{{c.label}}</small>
              </label>
              <input [formControlName]="c.name" type="text" class="form-control" id="simple-input-text-form-{{i}}"
                [matTooltip]="c.toolTip ?? ''">
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'hidden'"></ng-container>

          <ng-container *ngSwitchDefault>
            <ng-container *ngIf="fg.get(c.name)?.enabled">
              <label for="simple-input-text-form-{{i}}" class="form-label">
                {{c.alias ?? c.name}}
                <span *ngIf="c.required" class="text-red-400">*</span>
                <small *ngIf="c.label" class="text-muted text-xs">{{c.label}}</small>
              </label>
              <input [formControlName]="c.name" type="text" class="form-control" id="simple-input-text-form-{{i}}"
                [matTooltip]="c.toolTip ?? ''">
            </ng-container>
          </ng-container>

          <div *ngIf="fg.get(c.name)?.invalid && fg.get(c.name)?.touched" class="text-sm text-red-400">
            * {{c.alias ?? c.name}} is invalid.
          </div>

        </div>

      </div>
    </div>
  </div>
  <div class="card-footer">
    <div class="form-submit">
      <button [disabled]="data.isRequesting$|async" type="submit" class="custom-button custom-button-primary-filled">
        {{data.onSubmitText || 'Continue'}}
      </button>
      <button *ngIf="data.showCancelButton" [disabled]="data.isRequesting$|async" type="button" class="custom-button"
        mat-dialog-close>
        Cancel
      </button>
    </div>
  </div>
</form>